(function() {
	'use strict';
	var $ = avm.require('cash'),
		browser = avastGlobals.detect.browser,
		waypoints = avm.require('avast.web.waypoints'),
		$window = $(window),
		$worldSecurity = $('.js-world-security'),
		isWorldSecurityInViewport = false,
		counterAnimationTriggered = false;

	/**
	* securityInViewport - Animate security on scroll
	*/
	$window.on('scroll', securityInViewport);
	function securityInViewport() {
		if (waypoints($worldSecurity, 200)) {
			if (isWorldSecurityInViewport) {
				$window.off('scroll', securityInViewport);
			} else {
				isWorldSecurityInViewport = true;
				$worldSecurity.addClass('animate');
			}
		}
	}

	/**
	 * Should be a fix for the previous counter animation (causing issues for asisan languages + RTL languages that needed specific fix texts)
	 *
	 * counterAnimation - Animate number of ....
	 * Assumption is that the number may contain unit (such as B -billion or M -million - or even written out = such as 'Mld.' etc.) - and it is placed right of the number - such as XXB or XX Mld.
	 */
	 if (avastGlobals.web.language === 'en') {
		function counterAnimation() {
			var bAnimate = true;	// global flag - if at least one counter is not "animable" -> do not animate anything

			var timeout = setTimeout(function() {
				$('.js-info').each(function() {

					var timeAnim = 3;	// overall time of animation in sec, the tick is always set for 0,1 sec
					var sTrail = '';	// contains trailing chars behind number
					var $this = $(this);
					var numText = $this.text();

					numText = numText.replace(',', '.');
					var fstChar = numText.match(/[^\d.]/);
					if (fstChar != null) {
						sTrail = numText.substr(fstChar.index);
					}

					// asian langs have digits mixed w/ symbols -> do not animate!
					if (sTrail.match(/[\d]/g) == null) {
						var numVal = numText.replace(/[^\d.]/g, '');
						var numDecPlaces = numVal.indexOf('.') > -1 ? numVal.toString().split('.')[1].length : 0;

						var countUp = parseFloat(numVal);
						var incr = countUp / (10 * timeAnim);

						function updateTimer(currentNum) {
							if (currentNum <= countUp && bAnimate) {
								$this.text(currentNum.toFixed(numDecPlaces) + sTrail);
								currentNum += incr;
								setTimeout(updateTimer, 100, currentNum);
							} else if (currentNum > countUp) {
								$this.text(countUp + sTrail);
							}
						}

						if (countUp > 0) {
							updateTimer(0);
						}
					} else {
						bAnimate = false;
					}
				});
				clearTimeout(timeout);
			}, 500);
		}

		// run animation when appears in viewport
		$window.on('scroll', counting);
		function counting() {
			if (waypoints($worldSecurity, 0) && counterAnimationTriggered === false) {
				counterAnimationTriggered = true;
				counterAnimation();
			}
		}
	}
})();

// GLOWEB-6037
/*
Code for CONTROL version for Akamai AB test GLOWEB-5887
*/

(function() {
	'use strict';
	var browser = avastGlobals.detect.browser;


if (avastGlobals.web.locale === 'it-it' || avastGlobals.web.locale === 'pt-br' || avastGlobals.web.locale === 'es-es') {

// apply only for Windows paltform
if(avastGlobals.detect.os.isWindows && (!browser.isChrome) || avastGlobals.detect.os.isWindows && (browser.isOpera)) {

	var buttons = document.querySelectorAll('[data-platform="pc"][data-role="download-link"]');

	for (var i = 0; i < buttons.length; i++) {
		var button = buttons[i],
			downloadID = button.getAttribute('data-download-name');

		button.setAttribute('href', button.getAttribute('href').replace(downloadID, downloadID + '-GLOWEB-5887-0'));
		button.setAttribute('data-bi-download-name', downloadID + '-GLOWEB-5887-0');
		button.setAttribute('data-download-name', downloadID + '-GLOWEB-5887-0');

	}
}
}

})();
// /GLOWEB-6037
